<template>
	<nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);">
		<ol class="breadcrumb border-bottom p-3">
			<li class="breadcrumb-item">
				<router-link :to="{path: '/'}" class="text-decoration-none">Главная</router-link>
			</li>
			<li class="breadcrumb-item">
				<router-link :to="{path: '/users'}" class="text-decoration-none">Пользователи</router-link>
			</li>
			<li class="breadcrumb-item active">Группы пользователей</li>
		</ol>
	</nav>
	<div class="container-fluid">
		<div class="mb-3">
			<div class="float-end d-flex">
				<router-link :to="{path: '/users/groups/add'}" class="btn btn-primary d-flex align-items-center">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
						<path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
					</svg>
					<span class="d-none d-md-inline-block ms-2">Добавить группу пользователей</span>
				</router-link>
			</div>
			<h5>Группы пользователей</h5>
			<div class="text-muted">Управление группами пользователей</div>
		</div>
		<filter-bar 
			v-model:search="search" 
			v-model:limit="limit" 
			:loading="loading" 
		/>
		<div class="table-responsive">
			<table class="table table-hover table-bordered">
				<thead>
					<tr>
						<th>Название группы пользователей</th>
						<th width="25%">Пользователи</th>
						<th width="25%">Доступ к проектам</th>
						<th style="width: 125px;" class="text-center">Операции</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="group in groups" :key="group.id">
						<td class="align-middle">
							<div class="badge text-bg-dark font-monospace fs-6">@{{ group.name }}</div>
						</td>
						<td class="align-middle">
							<router-link
								:to="{path: '/users/' + user.id}"
								class="badge fs-6 text-danger border px-2 py-1 rounded text-decoration-none font-monospace me-1 mb-1"
								v-for="user in group.users" :key="user.id"
							>{{ user.login }}</router-link>
						</td>
						<td class="align-middle">
							<router-link
								:to="{path: '/projects/' + project_id}"
								class="badge text-bg-warning text-decoration-none font-monospace me-1"
								v-for="project in group.projects" :key="project.id"
								v-tippy="{placement: 'top'}"
								:title="project.name"
							>{{ project.apiname }}</router-link>
						</td>
						<td class="align-middle">
							<div class="d-grid gap-2 d-md-flex align-items-center justify-content-md-center">
								<router-link
									:to="{path: '/users/groups/' + group.id}"
									class="btn btn-primary d-flex align-items-center justify-content-center"
									:disabled="group.loading"
									title="Изменить"
									v-tippy="{placement: 'top'}"
								>
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M10,22C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.79,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,13L21.54,14.63C21.73,14.78 21.79,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.04 19.05,18.95L16.56,17.95C16.04,18.34 15.5,18.68 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10M11.25,4L10.88,6.61C9.68,6.86 8.62,7.5 7.85,8.39L5.44,7.35L4.69,8.65L6.8,10.2C6.4,11.37 6.4,12.64 6.8,13.8L4.68,15.36L5.43,16.66L7.86,15.62C8.63,16.5 9.68,17.14 10.87,17.38L11.24,20H12.76L13.13,17.39C14.32,17.14 15.37,16.5 16.14,15.62L18.57,16.66L19.32,15.36L17.2,13.81C17.6,12.64 17.6,11.37 17.2,10.2L19.31,8.65L18.56,7.35L16.15,8.39C15.38,7.5 14.32,6.86 13.12,6.62L12.75,4H11.25Z" />
									</svg>
								</router-link>
								<button
									type="button"
									class="btn btn-danger d-flex align-items-center justify-content-center"
									title="Удалить"
									v-tippy="{placement: 'top'}"
									:disabled="group.loading"
									@click="deleteGroup(group.id)"
								>
									<span v-if="group.loading" class="spinner-border spinner-border-sm" style="width: 24px; height: 24px;"></span>
									<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" />
									</svg>
								</button>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="text-center mt-2">
			<div class="mb-1">Всего групп пользователей: {{ groups_count }}</div>
			<pagination 
				v-model="page" 
				:total="groups_count" 
				:limit="limit" 
				:loading="loading"
				@change="loadData"
			/>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';
import { useModal } from "vue-final-modal";

import FilterBar from '@/components/FilterBar.vue';
import Pagination from '@/components/Pagination.vue';
import BootstrapConfirmModal from "@/components/modals/BootstrapConfirmModal.vue";

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Группы пользователей | SKV'});
	},
	data: () => ({
		groups: [],
		groups_count: 4,
		
		search: '',
		page: 1,
		limit: 25,
		loading: true,
	}),
	watch: {
		// Если пользователь нажал "Назад" или изменил URL, подгружаем данные заново
		'$route.query': {
			handler(newQuery) {
				this.search = newQuery.search || "";
				this.page = parseInt(newQuery.page) || 1;
				// Вызываем загрузку без push в роутер (чтобы не зациклиться)
				this.fetchGroups(); 
			},
			immediate: true,
		},
		search(newVal) {
			this.page = 1; // При поиске всегда сбрасываем на 1 страницу
			this.debouncedSearch();
		},
		limit(newVal) {
			this.page = 1;
			this.fetchGroups();
		},
	},
	methods: {
		async fetchGroups() {
			this.loading = true;
			const params = {
				search: this.search,
				start: (this.page - 1) * this.limit,
				limit: this.limit,
			};
			const ret = await this.appModel.doGetUserGroups(params);
			if (ret.success) {
				this.groups = ret.list.map(group => ({
					...group,
					loading: false,
				}));
				this.groups_count = ret.count;
			} else {
				this.$toast.error(ret.message);
			}
			this.loading = false;
		},
		debouncedSearch() {
			clearTimeout(this.debounceTimeout);
			this.debounceTimeout = setTimeout(() => {
				this.loadData();
			}, 500);
		},
		async loadData() {
			// Мы просто меняем URL, а Watcher сам увидит это и вызовет fetchUsers
			await this.$router.push({
				query: { 
					...this.$route.query, 
					search: this.search || undefined, 
					page: this.page,
				},
			}).catch(() => {});
		},
		
		async deleteGroup(id) {
			const group = this.groups.find(g => g.id === id);
			if (!group) return;
			
			useModal({
				component: BootstrapConfirmModal,
				attrs: {
					title: "Удаление группы пользователей",
					centered: true,
					confirmText: "Удалить группу",
					confirmColor: "danger",
					onConfirm: async () => {
						group.loading = true;
						try {
							const result = await this.appModel.doDeleteUserGroup(id);
							if (result.success) {
								this.fetchGroups();
							} else {
								this.$toast.error(result.message);
							}
						} finally {
							group.loading = false;
						}
					},
				},
				slots: {
					default: `Вы уверены, что хотите безвозвратно удалить группу "${group.name}"?`,
				},
			}).open();
		},
	},
	components: {
		FilterBar,
		Pagination,
	},
};
</script>
